/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DtcoDownloadLink
 */
export interface DtcoDownloadLink {
    /**
     * 
     * @type {string}
     * @memberof DtcoDownloadLink
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof DtcoDownloadLink
     */
    url: string;
}

export function DtcoDownloadLinkFromJSON(json: any): DtcoDownloadLink {
    return DtcoDownloadLinkFromJSONTyped(json, false);
}

export function DtcoDownloadLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): DtcoDownloadLink {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filename': json['filename'],
        'url': json['url'],
    };
}

export function DtcoDownloadLinkToJSON(value?: DtcoDownloadLink | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filename': value.filename,
        'url': value.url,
    };
}


